import { render, staticRenderFns } from "./ReportPageV2.vue?vue&type=template&id=2676f76d&scoped=true&"
import script from "./ReportPageV2.vue?vue&type=script&lang=js&"
export * from "./ReportPageV2.vue?vue&type=script&lang=js&"
import style0 from "./ReportPageV2.vue?vue&type=style&index=0&id=2676f76d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2676f76d",
  null
  
)

export default component.exports